import { classNames } from "../../utils/classes";
import { MdSpaceDashboard } from "react-icons/md";
import { TiDocumentText } from "react-icons/ti";
import { HiUsers } from "react-icons/hi";
import { GiGraduateCap } from "react-icons/gi";
import { BiLogOut } from "react-icons/bi";
import Link from "../../components/Button/LinkButton";
const icons = [
  { name: MdSpaceDashboard, href: "/dashboard/admin/home" },
  { name: TiDocumentText, href: "/dashboard/admin/appoinment" },
  { name: HiUsers, href: "/dashboard/admin/users" },
  { name: GiGraduateCap, href: "/dashboard/admin/countries" },
];
const SideBar = () => {
  let pathName = window.location.pathname;
  return (
    <div className="px-4 h-full border flex flex-col pt-6 justify-between items-center">
      <div class="flex flex-col space-y-6">
        {icons.map((icon, i) => {
          let Icon = icon.name;
          return (
            <>
              <Link as="button" to={icon.href} key={i}>
                <Icon
                  className={classNames(
                    "h-[40px] w-[40px]",
                    "hover:text-primary",
                    pathName === icon.href ? "text-primary " : "text-gray-400 "
                  )}
                />
              </Link>
              {/* <TiDocumentText className="text-gray-400 h-[40px] w-[40px]" />
              <HiUsers className="text-gray-400 h-[40px] w-[40px]" />
              <GiGraduateCap className="text-gray-400 h-[40px] w-[40px]" /> */}
            </>
          );
        })}
      </div>
      <div className="pb-4">
        <Link as="button" to={"/"}>
          <BiLogOut
            className={classNames(
              "text-gray-400 hover:text-red",
              "h-[40px] w-[40px]"
            )}
          />
        </Link>
      </div>
    </div>
  );
};
export default SideBar;
